import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import SportsSoccerRoundedIcon from '@mui/icons-material/SportsSoccerRounded';
import AppLayout from '../../components/ui/AppLayout';
import PageHeader from '../../components/ui/PageHeader';
import EmptyState from '../../components/ui/EmptyState';
import LoadingState from '../../components/ui/LoadingState';
import Game from './Game';
import api from '../../api';
import useTempoReal from '../../utils/tempoReal';
import { dataPelada } from '../../utils/dataPelada';
import { useAuth } from '../../AuthContext';

/**
 * /partidas — a aba Partidas da Confirmação em tela própria (atalho na barra de baixo do celular):
 * sorteio dos times (com pelo menos 8 no check-in), placar, fila de espera e resultado.
 */
const PartidasPage = () => {
  const navigate = useNavigate();
  const { userLogado } = useAuth();
  const [pelada, setPelada] = useState(undefined); // undefined = carregando; null = sem pelada aberta

  const carregar = () =>
    api
      .get('getPeladaActive')
      .then((r) => setPelada(r.data.data || null))
      .catch(() => setPelada((atual) => (atual === undefined ? null : atual)));

  useEffect(() => {
    carregar();
  }, []);

  // Check-ins e "foi embora" mudam quantos estão na fila para o sorteio
  useTempoReal(carregar);

  const naFila = pelada ? (pelada.arrivedPlayers || []).filter((p) => !p.saiu).length : 0;
  // Sortear: diretoria ou quem fez check-in nesta pelada (mesma regra da API)
  const ehDiretoria = userLogado && (userLogado.perfil === 'Admin' || userLogado.perfil === 'Diretor');
  const fezCheckin = pelada && (pelada.arrivedPlayers || []).some((p) => !p.guestId && String(p.user) === String(userLogado?._id));

  return (
    <AppLayout>
      <PageHeader
        eyebrow="Pelada"
        title="Partidas"
        subtitle={pelada ? `${dataPelada(pelada.date)} · ${naFila} na concentração` : undefined}
      />
      {pelada === undefined && <LoadingState label="Carregando a pelada..." />}
      {pelada === null && (
        <Card>
          <EmptyState
            icon={<SportsSoccerRoundedIcon />}
            title="Não há pelada aberta"
            description="As partidas aparecem aqui quando a pelada estiver aberta e os jogadores fizerem check-in."
            action={<Button variant="outlined" onClick={() => navigate('/ordem-chegada')}>Ir para a Confirmação</Button>}
          />
        </Card>
      )}
      {pelada && <Game jogadoresNoCheckin={naFila} podeSortear={Boolean(ehDiretoria || fezCheckin)} />}
    </AppLayout>
  );
};

export default PartidasPage;
